import * as React from "react";
import { observer } from "mobx-react";
import i18n from "i18n";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  IconButton,
  Link,
  Snackbar,
  Typography,
  Button,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import bgCard from "common/assets/images/tutorial/bg01.png";
import { WBSStore } from "modules/WBS/WBSStore";
import { DevelopmentStore } from "../../DevelopmentStore";

const styles = (theme) => ({
  gridContent: {
    position: "absolute" as any,
    left: 0,
    top: 0,
    backgroundColor: "rgba(0,0,0,0.4)" as any,
    width: "100%",
    height: "100%",
    zIndex: 99999,
    display: "flex",
    flexDirection: "column" as any,
    justifyContent: "center" as any,
    alignItems: "center",
  },
  card: { backgroundColor: "#2E2E2E", width: "35.688rem" },
  cardHeader: {
    backgroundColor: "#3A393E",
    fontSize: "24px",
    padding: "14px",
    textAlign: "center" as any,
    "& span": {
      color: "#9AAF00",
      fontWeight: "700" as any,
      lineHeight: "28px",
      fontFamily: "Roboto",
    },
  },
  cardActions: {
    backgroundColor: "#3A393E",
    justifyContent: "space-between",
    padding: "20px 12px",
    "& label": {
      "& span": {
        color: "#EEEEEE",
        fontSize: "0.75rem",
        lineHeight: "0.875rem",
        "& svg": { fontSize: "1.188rem" },
      },
    },
  },
  cardTxt01: {
    color: " #9AAF00",
    textAlign: "center" as any,
    fontWeight: 700,
    fontSize: "1rem",
    lineHeight: "1.188rem",
    textTransform: "uppercase" as any,
    margin: "30px 0 20px 0",
  },
  cardTxt02: {
    color: " #EEEEEE",
    textAlign: "center" as any,
    fontWeight: 400,
    fontSize: "0.938rem",
    lineHeight: "1.125rem",
    marginBottom: 59,
  },
  btnNext: {
    backgroundColor: "#9AAF00",
    color: "#FFFFFF",
    padding: "8px 16px 8px 16px",
    fontSize: "14px",
    transition: ".3s",
    marginBottom: "24px",
    "&:hover": { backgroundColor: "#697513" },
  },
  link: {
    color: "#FFFFFF",
    textAlign: "center" as any,
    textDecoration: "underline" as any,
    fontSize: "0.875rem",
    lineHeight: "1rem",
    fontWeight: 400,
    cursor: "pointer",
  },
  snack: {
    "& > div": {
      display: "flex",
      flexDirection: "row" as any,
      flexWrap: "nowrap" as any,
    },
  },
});

interface IProps {
  classes: any;
}
@observer
class SubscribeNowCard extends React.Component<IProps> {
  state = {
    openSnack: false,
  };

  handleSendClickTrack = () => {
    DevelopmentStore.sendClickTrackToHubspot().then(() => {
      this.setState({ openSnack: true });
      WBSStore.subscribeShowChange(false);
    });
  };

  render() {
    const { classes } = this.props;
    let card: any;

    if (WBSStore.subscribeShow) {
      card = (
        <>
          <Grid className={classes.gridContent}>
            <Card className={classes.card}>
              <CardHeader
                title={i18n.trialRegister.subcribeCard.cadTitle}
                className={classes.cardHeader}
              />
              <CardContent
                style={{
                  padding: "24px 38px",
                  backgroundImage: `url(${bgCard})`,
                  backgroundPositionX: "-7px",
                  height: "312px",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <Grid container direction="column">
                  <Typography className={classes.cardTxt01}>
                    {i18n.trialRegister.subcribeCard.cardTxt01}
                  </Typography>
                  <Typography className={classes.cardTxt02}>
                    <b>{i18n.trialRegister.subcribeCard.cardTxt02}</b>
                    {i18n.trialRegister.subcribeCard.cardTxt03}
                  </Typography>
                  <Grid
                    direction="column"
                    alignItems="center"
                    item
                    style={{ display: "flex" }}
                  >
                    <Button
                      className={classes.btnNext}
                      fullWidth={false}
                      onClick={this.handleSendClickTrack}
                      id="CliqueBtnAssineAgora"
                    >
                      {i18n.trialRegister.subcribeCard.textButton}
                    </Button>
                  </Grid>
                  <Link
                    className={classes.link}
                    onClick={() => {
                      WBSStore.subscribeShowChange(false);
                    }}
                  >
                    {i18n.trialRegister.subcribeCard.textBack}
                  </Link>
                </Grid>
              </CardContent>
              <CardActions className={classes.cardActions}></CardActions>
            </Card>
          </Grid>
        </>
      );
    } else {
      card = (
        <>
          <Snackbar
            key={1}
            style={{ display: "flex" }}
            className={classes.snack}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={this.state.openSnack}
            autoHideDuration={6000}
            onClose={() => this.setState({ openSnack: !this.state.openSnack })}
            message={
              <span id="message-id">
                {i18n.trialRegister.subcribeCard.snackText01} <br />
                {i18n.trialRegister.subcribeCard.snackText02}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={() =>
                  this.setState({ openSnack: !this.state.openSnack })
                }
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </>
      );
    }

    return card;
  }
}

export default withStyles(styles)(SubscribeNowCard);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/SubscribeNowCard.tsx